import { useState } from "react";
import CreatorModePanelWrapper from "../../../../components/CreatorDashboard/CreatorModePanelWrapper";
import { Colors } from "../../../../utils/colors";
import MembershipPlans from "../../../../components/CreatorDashboard/Memberships/MembershipPlans";
import MembershipMembers from "../../../../components/CreatorDashboard/Memberships/MembershipMembers";
import FatHeaderActionButton from "../../../../components/Buttons/FatHeaderActionButton";
import { Icon } from "@iconify/react";
import { convertToMoney, hasSubscription } from "@markit/common.utils";
import { useSelector } from "react-redux";
import {
  getAccountSlice,
  getIncompleteOnboardingFlows,
} from "../../../../redux/slices/accountSlice";
import { MembershipState, OnboardingFlowType } from "@markit/common.types";
import useAsyncOnMount from "../../../../hooks/useAsyncEffectOnMount";
import { getFollowerSubscriptionsMonthlyRevenue } from "../../../../utils/followerSubscriptionUtils";
import ShareMembershipLinkModal from "../../../../components/CreatorDashboard/CreatorProfile/ShareMembershipLinkModal";
import { MembershipsPromoCodePanel } from "../../../../components/CreatorDashboard/Memberships/MembershipsPromoCodePanel";
import { useLocation } from "react-router-dom";

enum MembershipTabs {
  MEMBERS = 0,
  PROMOS = 1,
  PLANS = 2,
}

const MembershipsPanel = () => {
  const { accountData } = useSelector(getAccountSlice);
  const incompleteOnboardingFlows = useSelector(getIncompleteOnboardingFlows);
  const { initialTabValue } = useLocation().state || {};
  const [tabValue, setTabValue] = useState<MembershipTabs>(
    initialTabValue ??
      (incompleteOnboardingFlows.some(
        (flow) => flow.id === OnboardingFlowType.PAID_MEMBERSHIP
      )
        ? MembershipTabs.PLANS
        : MembershipTabs.MEMBERS)
  );
  const [listValue, setListValue] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [shareMembershipLink, setShareMembershipLink] = useState(false);

  const styles = {
    bodyContainer: {
      backgroundColor:
        tabValue === MembershipTabs.MEMBERS ||
        tabValue === MembershipTabs.PROMOS
          ? Colors.WHITE
          : Colors.WHITE1,
      padding: 30,
      flex: 1,
    },
  };

  useAsyncOnMount(async () => {
    const totalMonthRevenue = await getFollowerSubscriptionsMonthlyRevenue(
      accountData.uid,
      accountData.membership.membershipPlans
    );
    setTotalRevenue(totalMonthRevenue);
  });

  return (
    <CreatorModePanelWrapper
      title={"Memberships"}
      headerTabs={{
        tabNames: ["Members", "Promos", "Plans"],
        tabValue: tabValue,
        setTabValue: setTabValue,
      }}
      headerRight={
        accountData.membership.state === MembershipState.ACTIVE &&
        hasSubscription(accountData) ? (
          <div className="AlignedRow" style={{ gap: 20 }}>
            {totalRevenue > 0 ? (
              <div className="ColumnNormal" style={{ alignItems: "center" }}>
                <span style={{ fontSize: 28 }}>
                  {convertToMoney(totalRevenue)}
                </span>
                <span className="smallBodySubtext">
                  Monthly Subscription Revenue
                </span>
              </div>
            ) : null}
            <div>
              <FatHeaderActionButton
                title="Membership Link"
                icon={
                  <Icon
                    icon="ion:share"
                    height={19}
                    style={{ color: Colors.WHITE, paddingBottom: 2 }}
                  />
                }
                onPress={() => setShareMembershipLink(true)}
                containerStyles={{
                  paddingBlock: 0,
                  height: 46,
                  backgroundColor: Colors.BLACK,
                  color: Colors.WHITE,
                  border: "none",
                }}
              />
            </div>
          </div>
        ) : null
      }
    >
      <div style={styles.bodyContainer}>
        <MembershipMembers
          tabValue={tabValue}
          setTabValue={setTabValue}
          listValue={listValue}
          setListValue={setListValue}
        />
        <MembershipsPromoCodePanel
          tabValue={tabValue}
          setTabValue={setTabValue}
        />
        <MembershipPlans
          tabValue={tabValue}
          setTabValue={setTabValue}
          setListValue={setListValue}
        />
      </div>
      {shareMembershipLink ? (
        <ShareMembershipLinkModal
          username={accountData.username}
          setShareLinkModal={setShareMembershipLink}
        />
      ) : null}
    </CreatorModePanelWrapper>
  );
};

export default MembershipsPanel;
